import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'react-toastify'
import { update } from '../../../app/setters/update.js'

export const useZapiszKomunikatPowitalny = () => {
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: (data) => update('/oper/komunikat', data),
        onSuccess: ({ message }) => {
            queryClient.invalidateQueries({ queryKey: ['komunikat-powitalny'] })
            toast.success(message)
        },
    })
}
